class ApiPaths {
    // tslint:disable: member-ordering
    /**
     * Api endpoint base path to get events
     */
    private eventsBasePath = '/events';
    /**
     * Api endpoint base path to get configuration files
     */
    private configurationBasePath = '/configuration';
    /**
     * Api endpoint base path to get reports
     */
    private reportBasePath = `/report`;
    /**
     * Api endpoint base path to get filters
     */
    private filterBasePath = `/filter`;
    /**
     * Api endpoint base path to get filters
     */
    private quickGuideBasePath = `/quickGuide`;
    /**
     * Api endpoint base path to get units from MyMill
     */
    private myMillUnitBasePath = `/mymill`;

    /**
     * Api endpoint path to crerate an event
     */
    public eventsCreate: string = `${this.eventsBasePath}/create`;
    /**
     * Api endpoint path to get a snapshot of the data sets
     */
    public eventsCurrent: string = `${this.eventsBasePath}/current`;
    /**
     * Api endpoint path to delete an event
     */
    public eventsDelete: string = `${this.eventsBasePath}/delete`;
    /**
     * Api endpoint path to update an event
     */
    public eventsUpdate: string = `${this.eventsBasePath}/update`;

    /**
     * Api endpoint path to get a configuration file for general sections
     */
    public configurationGeneral = `${this.configurationBasePath}/fields`;
    /**
     * Api endpoint path to get a configuration file for machine/process sections
     */
    public configurationMachines = `${this.configurationBasePath}/machinesFields`;
    /**
     * Api endpoint path to get a configuration file for sample sections
     */
    public configurationSamples = `${this.configurationBasePath}/newSampleFields`;
    /**
     * Api endpoint path to get a configuration file for units
     */
    public configurationUnits = `${this.configurationBasePath}/units`;
    /**
     * Api endpoint path to get a configuration file for mymill import sections
     */
    public configurationMymillImport = `${this.configurationBasePath}/mymillFields`;

    /**
     * A list of user which have access to the app
     * This is just a temp solution till MyIdenty provieds correct role
     * TODO: remoce later?
     */
    public configurationUserWhitelist = `${this.configurationBasePath}/userWhitelist`;

    /**
     * Api endpoint path to get list of report files
     */
    public reports = `${this.reportBasePath}/reports`;

    /**
     * Api endpoint path to add a filter
     */
    public addFilter = `${this.filterBasePath}/add`;

    /**
     * Api endpoint path to get filters
     */
    public getFilters = `${this.filterBasePath}/filters`;

    /**
     * Api endpoint path to delete a filter
     */
    public removeFilter = `${this.filterBasePath}/delete`;

    /**
     * Api endpoint path to update a filter
     */
    public updateFilter = `${this.filterBasePath}/update`;

    /**
     * Api endpoint path to share a filter
     */
    public shareFilter = `${this.filterBasePath}/share`;

    /**
     * Api endpoint base path to get quick guide document url
     */
    public quickQuide = `${this.quickGuideBasePath}/quickGuide`;

    /**
     * Api endpoint base path to get quick edit parameters list
     */
    public quickEdit = `${this.configurationBasePath}/simplifiedForms`;

    /**
     * Api endpoint path to get units from MyMill
     */
    public myMillUnits = `${this.myMillUnitBasePath}/units`;

    /**
     * Api endpoint path to get unit status from MyMill
     */
    public myMillUnitStatus = `${this.myMillUnitBasePath}/units/status`;


    /**
     * Api endpoint path to get a ping from the api
     * TODO: add an extra endpoint for this
     */
    public onlinePing = `/ping`;

    // tslint:enable: member-ordering

    // tslint:disable-next-line: no-empty
    constructor() { }

    /**
     * Api endpoint path to get all events since a specific event id.
     */
    public eventsSince = (sinceEventId?: number) => sinceEventId == null ? `${this.eventsBasePath}/since` : `${this.eventsBasePath}/since?eventId=${sinceEventId}`;

    /**
     * Api endpoint path to get a configuration file for ax customers
     */
    public configurationAxCustomers = (onlyDate: boolean) => `${this.configurationBasePath}/axCustomers?getOnlyDate=${onlyDate}`;
    /**
     * Api endpoint path to get a configuration file for ax machine models
     */
    public configurationAxMachineModels = (onlyDate: boolean) => `${this.configurationBasePath}/axMachineModels?getOnlyDate=${onlyDate}`;
}

export default ApiPaths;
